import { Link } from 'react-router-dom';
import { Newspaper, ShoppingBag, Users, User, Home } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext'
import useSound from '../hooks/useSound';

interface Props {
  isActive: (path: string) => boolean;
  onProfileClick: () => void;
}

const MobileBottomNav = ({ isActive, onProfileClick }: Props) => {
  const playNavigation = useSound('navigation');
  const { user } = useAuth()
  // No favorites in bottom nav for this version; central Reels button is primary focus
  return (
     <nav className="fixed bottom-0 left-0 right-0 bg-noe-950 border-t border-noe-800 z-50 md:hidden flex justify-between items-stretch py-2 px-2">
      <div className="flex-1 flex justify-center items-center">
        <Link to="/news" onClick={playNavigation} className={`flex flex-col items-center gap-1 ${isActive('/news') ? 'text-noe-brand' : 'text-noe-300'}`}>
          <div className="relative inline-block"><Newspaper className="w-5 h-5" /></div>
          <span className="text-xs">Notícias</span>
        </Link>
      </div>
      <div className="flex-1 flex justify-center items-center">
        <Link to="/listings" onClick={playNavigation} className={`flex flex-col items-center gap-1 ${isActive('/listings') ? 'text-noe-brand' : 'text-noe-300'}`}>
          <div className="relative inline-block"><ShoppingBag className="w-5 h-5" /></div>
          <span className="text-xs">Marketplace</span>
        </Link>
      </div>
      {/* Central Reels button */}
      <div className="flex-1 flex justify-center items-center relative" aria-label="Reels">
        <Link to="/reels" onClick={playNavigation} className="relative -top-4">
           <div className="w-14 h-14 rounded-full bg-noe-brand text-white hover:bg-noe-brandHover flex items-center justify-center shadow-lg transition-colors">
              <Home className="w-7 h-7" />
          </div>
        </Link>
      </div>
       <div className="flex-1 flex justify-center items-center">
        <Link to="/groups" onClick={(e) => { console.log('Groups link clicked', e); playNavigation(); }} className={`flex flex-col items-center gap-1 ${isActive('/groups') ? 'text-noe-brand' : 'text-noe-300'}`}>
          <div className="relative inline-block"><Users className="w-5 h-5" /></div>
          <span className="text-xs">Grupos</span>
        </Link>
      </div>
      <div className="flex-1 flex justify-center items-center">
        {user ? (
          <button onClick={() => { /* existing profile action */ onProfileClick(); }} className="flex flex-col items-center gap-1 text-noe-300 hover:text-noe-brand">
            <div className="relative inline-block"><User className="w-5 h-5" /></div>
            <span className="text-xs">Perfil</span>
          </button>
         ) : (
           <Link to="/login" onClick={(e) => { console.log('Login link clicked', e); playNavigation(); }} className="flex flex-col items-center gap-1 text-noe-300 hover:text-noe-brand">
             <User className="w-5 h-5" />
             <span className="text-xs">Login</span>
           </Link>
         )}
      </div>
    </nav>
  );
};

export default MobileBottomNav;
